var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAlcohol)?_c('v-alert',{staticClass:"my-3",attrs:{"type":"warning","dense":""}},[_vm._v("A person with a valid ID and age over 21 must present in receiving the order.")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }